import {gql} from "@apollo/client";

export default gql`
  mutation cancelRecurringJob($data: DeleteRecurringJobInput!) {
    cancelRecurringJob(data: $data)
  }
`;